import ReactGA from "react-ga4";



const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_ID;


export const initGA = () => {
  ReactGA.initialize(GA_MEASUREMENT_ID);
};

export const trackPage = (path) => {
  ReactGA.send({
    hitType: "pageview",
    page: path,
  });
};

export const trackEvent = (action, category, label) => {
  ReactGA.event({
    action,
    category,
    label,
  });
};
